/**
 * True on the OAuth callback page while it still carries its authorization code. That page exchanges the code
 * for a fresh token pair itself, so nothing should refresh a remembered token before it has done so.
 */
export function isOAuthCallbackWithCode(location: Pick<Location, "pathname" | "search"> = window.location): boolean {
  return location.pathname.endsWith("/oauth/v2/callback") && new URLSearchParams(location.search).has("code");
}

/** What the authorization server appends to the callback URL; none of it may survive a page refresh. */
const OAUTH_CALLBACK_PARAMS = ["code", "state", "session_state", "iss"] as const;

/**
 * Takes the authorization code and state out of the address bar without a navigation, so a refresh of the callback
 * page never exchanges the same (already used) code again. The router's history state is kept as it is.
 */
export function stripOAuthCallbackParams(): void {
  const url = new URL(window.location.href);
  const present = OAUTH_CALLBACK_PARAMS.filter(param => url.searchParams.has(param));
  if (present.length === 0) {
    return;
  }
  for (const param of present) {
    url.searchParams.delete(param);
  }
  window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
}
